export default __webpack_public_path__ + "static/media/006-firecracker.fde7ed3f.svg";